<template>
    <rkm-overlay>
        <rkm-layout-body title="Unificação de usuário/paciente">
            <template v-slot:actions>
                <rkm-button
                :disabled="!isButtonEnabled"
                    @click="confirmForm"
                    color="warning"
                >
                    Unificar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form @usuarioSelected="onUsuarioSelected" ref="Form" />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/cadastro/unifica-cidadao/Form'

export default {
    data: () => ({
        isButtonEnabled: false,
        formReady: false,
    }),
    components: { Form },
    methods: {
        confirmForm() {

            if (this.formReady && this.$refs.Form) {

                this.$refs.Form.confirm();
            }
        },
        onUsuarioSelected(value) {

            if (value) {

                this.isButtonEnabled = true;
            } else {

                this.isButtonEnabled = false;
            }
        }
    },
    mounted() {

        this.formReady = true;
    }
}
</script>